import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShipmentModifiedByDetails } from './normalize';

export const fetchShipmentModifiedByDetails = createProvider(api.fetchShipmentModifiedByDetails)
  .andThen((res) => normalizeShipmentModifiedByDetails(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
